import React, { useState, useEffect } from 'react';
import './LibroReclamaciones.css';
import { Link } from 'react-router-dom';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/reclamaciones.php';

/* ── Logo ── */
const LogoComunicar = ({ height = 40 }) => (
  <img 
    src="/images/logo_centro.png" 
    alt="Comunicar" 
    style={{ height: height, width: 'auto', display: 'block' }}
  />
);

/* ── Icons ── */
const IconArrow    = () => <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconCheck    = () => <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><circle cx="10" cy="10" r="9" fill="rgba(130,216,179,.2)"/><path d="M6 10l3 3 5-5" stroke="#4db88a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconSpinner  = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{animation:'spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconBook     = () => <svg viewBox="0 0 24 24" fill="none" width="28" height="28"><path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconSearch   = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconAlert    = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconShield   = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconUser     = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconFile     = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;

/* ── Pasos del formulario ── */
const PASOS = [
  { id: 1, label: 'Identificacion', icon: IconUser },
  { id: 2, label: 'Bien o servicio', icon: IconFile },
  { id: 3, label: 'Detalle', icon: IconBook },
];

const ESTADO_LABELS = {
  pendiente:   { label: 'Pendiente de revision', color: '#f59e0b', bg: '#fef3c7' },
  en_proceso:  { label: 'En proceso',            color: '#3b82f6', bg: '#dbeafe' },
  resuelto:    { label: 'Resuelto',              color: '#22c55e', bg: '#dcfce7' },
  cerrado:     { label: 'Cerrado',               color: '#6b7280', bg: '#f3f4f6' },
};

const INITIAL_FORM = {
  tipo_persona: 'natural', nombres: '', apellidos: '', tipo_doc: 'DNI',
  num_doc: '', email: '', telefono: '', domicilio: '', menor_edad: false,
  nombre_apoderado: '', tipo_reclamo: 'reclamo', tipo_bien: 'servicio',
  descripcion_bien: '', monto: '', pedido_codigo: '',
  detalle: '', pedido_consumidor: '', acepta_terminos: false,
};

export default function LibroReclamaciones() {
  const [tab,        setTab]        = useState('registrar');
  const [paso,       setPaso]       = useState(1);
  const [form,       setForm]       = useState(INITIAL_FORM);
  const [errores,    setErrores]    = useState({});
  const [enviando,   setEnviando]   = useState(false);
  const [resultado,  setResultado]  = useState(null);

  const [codConsulta,    setCodConsulta]    = useState('');
  const [emailConsulta,  setEmailConsulta]  = useState('');
  const [consultando,    setConsultando]    = useState(false);
  const [resultConsulta, setResultConsulta] = useState(null);
  const [errorConsulta,  setErrorConsulta]  = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [paso]);

  function set(campo, valor) {
    setForm(function(prev) { return Object.assign({}, prev, { [campo]: valor }); });
    setErrores(function(prev) { var n = Object.assign({}, prev); delete n[campo]; return n; });
  }

  function validarPaso1() {
    var err = {};
    if (!form.nombres.trim())    err.nombres    = 'Requerido';
    if (!form.apellidos.trim())  err.apellidos  = 'Requerido';
    if (!form.num_doc.trim())    err.num_doc    = 'Requerido';
    if (!form.email.includes('@')) err.email    = 'Email no valido';
    if (form.menor_edad && !form.nombre_apoderado.trim()) err.nombre_apoderado = 'Requerido para menores de edad';
    return err;
  }

  function validarPaso2() {
    var err = {};
    if (!form.descripcion_bien.trim()) err.descripcion_bien = 'Requerido';
    return err;
  }

  function validarPaso3() {
    var err = {};
    if (!form.detalle.trim() || form.detalle.trim().length < 20) err.detalle = 'Describe el detalle (minimo 20 caracteres)';
    if (!form.pedido_consumidor.trim()) err.pedido_consumidor = 'Requerido';
    if (!form.acepta_terminos) err.acepta_terminos = 'Debes aceptar para continuar';
    return err;
  }

  function siguientePaso() {
    var err = paso === 1 ? validarPaso1() : paso === 2 ? validarPaso2() : {};
    if (Object.keys(err).length > 0) { setErrores(err); return; }
    setPaso(function(p) { return p + 1; });
  }

  async function handleEnviar(e) {
    e.preventDefault();
    var err = validarPaso3();
    if (Object.keys(err).length > 0) { setErrores(err); return; }
    setEnviando(true);
    try {
      var res = await fetch(API + '?action=crear', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      var json = await res.json();
      if (!json.success) throw new Error(json.message || 'Error al enviar');
      setResultado(json.data);
    } catch(err2) {
      setErrores({ submit: err2.message || 'Error al enviar. Intenta de nuevo.' });
    } finally {
      setEnviando(false);
    }
  }

  async function handleConsultar(e) {
    e.preventDefault();
    setErrorConsulta('');
    setResultConsulta(null);
    if (!codConsulta.trim() || !emailConsulta.trim()) {
      setErrorConsulta('Ingresa el codigo y tu email'); return;
    }
    setConsultando(true);
    try {
      var res = await fetch(API + '?action=consultar&codigo=' + encodeURIComponent(codConsulta) + '&email=' + encodeURIComponent(emailConsulta));
      var json = await res.json();
      if (!json.success) throw new Error(json.message);
      setResultConsulta(json.data);
    } catch(err2) {
      setErrorConsulta(err2.message || 'No se encontro el reclamo');
    } finally {
      setConsultando(false);
    }
  }

  if (resultado) {
    return (
      <div className="lr-page">
        <nav className="lr-nav">
          <Link to="/" className="lr-nav__logo"><LogoComunicar height={42}/></Link>
          <Link to="/" className="lr-nav__back">Volver al inicio</Link>
        </nav>
        <div className="lr-exito">
          <div className="lr-exito__inner">
            <div className="lr-exito__icon">
              <svg viewBox="0 0 24 24" fill="none" width="48" height="48">
                <circle cx="12" cy="12" r="10" fill="#d4f4e8"/>
                <path d="M8 12l3 3 5-5" stroke="#4db88a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h1>Reclamo registrado</h1>
            <p>Tu reclamo ha sido recibido exitosamente. Hemos enviado una confirmacion a tu correo electronico.</p>
            <div className="lr-exito__codigo">
              <span>Numero de codigo</span>
              <strong>{resultado.codigo}</strong>
            </div>
            <div className="lr-exito__info">
              <div><IconShield/><span>Guardamos tu codigo para seguimiento. El plazo de atencion es de <strong>30 dias habiles</strong> segun la Ley N 29571.</span></div>
            </div>
            <div className="lr-exito__btns">
              <button className="lr-btn lr-btn--primary" onClick={function() { setResultado(null); setForm(INITIAL_FORM); setPaso(1); }}>
                Registrar otro reclamo
              </button>
              <Link to="/" className="lr-btn lr-btn--ghost">Volver al inicio</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="lr-page">

      {/* NAV */}
      <nav className="lr-nav">
        <Link to="/" className="lr-nav__logo"><LogoComunicar height={42}/></Link>
        <Link to="/" className="lr-nav__back">← Volver al inicio</Link>
      </nav>

      {/* HEADER */}
      <div className="lr-header">
        <div className="lr-header__inner">
          <div className="lr-header__icon"><IconBook/></div>
          <div>
            <p className="lr-header__sello">Libro de Reclamaciones Virtual</p>
            <h1>Libro de <em>Reclamaciones</em></h1>
            <p className="lr-header__sub">
              Conforme al Art. 150 del Codigo de Proteccion y Defensa del Consumidor (Ley N 29571).
              COMUNICAR DESARROLLO Y LENGUAJE EIRL — RUC: 20615646939
            </p>
          </div>
        </div>
        <div className="lr-header__aviso">
          <IconAlert/>
          <p>
            La formulacion del reclamo no impide acudir a otras vias de solucion de controversias ni
            es requisito previo para interponer una denuncia ante el INDECOPI.
            El proveedor debe dar respuesta en un plazo no mayor a <strong>30 dias habiles</strong>.
          </p>
        </div>
      </div>

      {/* TABS */}
      <div className="lr-tabs">
        <button
          className={'lr-tab ' + (tab === 'registrar' ? 'lr-tab--active' : '')}
          onClick={function() { setTab('registrar'); }}
        >
          <IconBook/> Registrar reclamo
        </button>
        <button
          className={'lr-tab ' + (tab === 'consultar' ? 'lr-tab--active' : '')}
          onClick={function() { setTab('consultar'); }}
        >
          <IconSearch/> Consultar estado
        </button>
      </div>

      <div className="lr-body">

        {/* ════════ TAB REGISTRAR ════════ */}
        {tab === 'registrar' && (
          <div className="lr-form-wrap">

            {/* Stepper */}
            <div className="lr-stepper">
              {PASOS.map(function(p) {
                var estado = paso > p.id ? 'done' : paso === p.id ? 'active' : 'pending';
                return (
                  <React.Fragment key={p.id}>
                    <div className={'lr-step lr-step--' + estado}>
                      <div className="lr-step__dot">
                        {estado === 'done' ? <IconCheck/> : <span>{p.id}</span>}
                      </div>
                      <span className="lr-step__label">{p.label}</span>
                    </div>
                    {p.id < PASOS.length && (
                      <div className={'lr-step__line ' + (paso > p.id ? 'lr-step__line--done' : '')}/>
                    )}
                  </React.Fragment>
                );
              })}
            </div>

            {/* ── PASO 1: Identificacion del consumidor ── */}
            {paso === 1 && (
              <div className="lr-form-section">
                <div className="lr-form-section__head">
                  <IconUser/>
                  <div>
                    <h2>Datos del consumidor</h2>
                    <p>Ingresa tus datos personales. Seran utilizados unicamente para atender tu reclamo.</p>
                  </div>
                </div>

                <div className="lr-campo">
                  <label>Tipo de persona</label>
                  <div className="lr-radio-group">
                    {[{val:'natural',label:'Persona natural'},{val:'juridica',label:'Persona juridica'}].map(function(op) {
                      return (
                        <label key={op.val} className={'lr-radio ' + (form.tipo_persona === op.val ? 'lr-radio--active' : '')}>
                          <input type="radio" name="tipo_persona" value={op.val} checked={form.tipo_persona === op.val} onChange={function(e) { set('tipo_persona', e.target.value); }}/>
                          {op.label}
                        </label>
                      );
                    })}
                  </div>
                </div>

                <div className="lr-grid-2">
                  <div className="lr-campo">
                    <label>Nombres <span className="lr-req">*</span></label>
                    <input type="text" placeholder="Ej: Ana Maria" value={form.nombres} onChange={function(e) { set('nombres', e.target.value); }} className={errores.nombres ? 'lr-input--error' : ''}/>
                    {errores.nombres && <span className="lr-error">{errores.nombres}</span>}
                  </div>
                  <div className="lr-campo">
                    <label>Apellidos <span className="lr-req">*</span></label>
                    <input type="text" placeholder="Ej: Garcia Lopez" value={form.apellidos} onChange={function(e) { set('apellidos', e.target.value); }} className={errores.apellidos ? 'lr-input--error' : ''}/>
                    {errores.apellidos && <span className="lr-error">{errores.apellidos}</span>}
                  </div>
                </div>

                <div className="lr-grid-2">
                  <div className="lr-campo">
                    <label>Tipo de documento <span className="lr-req">*</span></label>
                    <select value={form.tipo_doc} onChange={function(e) { set('tipo_doc', e.target.value); }}>
                      <option value="DNI">DNI</option>
                      <option value="CE">Carnet de Extranjeria</option>
                      <option value="PASAPORTE">Pasaporte</option>
                      <option value="RUC">RUC</option>
                    </select>
                  </div>
                  <div className="lr-campo">
                    <label>Numero de documento <span className="lr-req">*</span></label>
                    <input type="text" placeholder="Ej: 12345678" value={form.num_doc} onChange={function(e) { set('num_doc', e.target.value); }} className={errores.num_doc ? 'lr-input--error' : ''}/>
                    {errores.num_doc && <span className="lr-error">{errores.num_doc}</span>}
                  </div>
                </div>

                <div className="lr-grid-2">
                  <div className="lr-campo">
                    <label>Correo electronico <span className="lr-req">*</span></label>
                    <input type="email" placeholder="tu@correo.com" value={form.email} onChange={function(e) { set('email', e.target.value); }} className={errores.email ? 'lr-input--error' : ''}/>
                    {errores.email && <span className="lr-error">{errores.email}</span>}
                  </div>
                  <div className="lr-campo">
                    <label>Telefono / WhatsApp</label>
                    <input type="tel" placeholder="9XX XXX XXX" value={form.telefono} onChange={function(e) { set('telefono', e.target.value); }}/>
                  </div>
                </div>

                <div className="lr-campo">
                  <label>Domicilio</label>
                  <input type="text" placeholder="Direccion, distrito, ciudad" value={form.domicilio} onChange={function(e) { set('domicilio', e.target.value); }}/>
                </div>

                <div className="lr-campo">
                  <label className="lr-checkbox">
                    <input type="checkbox" checked={form.menor_edad} onChange={function(e) { set('menor_edad', e.target.checked); }}/>
                    <span>El consumidor es menor de edad</span>
                  </label>
                </div>

                {form.menor_edad && (
                  <div className="lr-campo">
                    <label>Nombre del padre/madre o apoderado <span className="lr-req">*</span></label>
                    <input type="text" placeholder="Nombre completo del apoderado" value={form.nombre_apoderado} onChange={function(e) { set('nombre_apoderado', e.target.value); }} className={errores.nombre_apoderado ? 'lr-input--error' : ''}/>
                    {errores.nombre_apoderado && <span className="lr-error">{errores.nombre_apoderado}</span>}
                  </div>
                )}

                <div className="lr-form-actions">
                  <div/>
                  <button type="button" className="lr-btn lr-btn--primary" onClick={siguientePaso}>
                    Continuar <IconArrow/>
                  </button>
                </div>
              </div>
            )}

            {/* ── PASO 2: Bien o servicio ── */}
            {paso === 2 && (
              <div className="lr-form-section">
                <div className="lr-form-section__head">
                  <IconFile/>
                  <div>
                    <h2>Identificacion del bien o servicio</h2>
                    <p>Indica el curso o material sobre el cual presentas tu reclamo.</p>
                  </div>
                </div>

                <div className="lr-campo">
                  <label>Tipo de reclamo <span className="lr-req">*</span></label>
                  <div className="lr-radio-group">
                    <label className={'lr-radio lr-radio--reclamo ' + (form.tipo_reclamo === 'reclamo' ? 'lr-radio--active' : '')}>
                      <input type="radio" name="tipo_reclamo" value="reclamo" checked={form.tipo_reclamo === 'reclamo'} onChange={function(e) { set('tipo_reclamo', e.target.value); }}/>
                      <div>
                        <strong>Reclamo</strong>
                        <span>Disconformidad relacionada a los productos o servicios</span>
                      </div>
                    </label>
                    <label className={'lr-radio lr-radio--queja ' + (form.tipo_reclamo === 'queja' ? 'lr-radio--active' : '')}>
                      <input type="radio" name="tipo_reclamo" value="queja" checked={form.tipo_reclamo === 'queja'} onChange={function(e) { set('tipo_reclamo', e.target.value); }}/>
                      <div>
                        <strong>Queja</strong>
                        <span>Disconformidad relacionada a la atencion al consumidor</span>
                      </div>
                    </label>
                  </div>
                  <div className="lr-tipo-nota">
                    <IconAlert/>
                    <span>
                      <strong>Reclamo:</strong> disconformidad con el bien o servicio adquirido.
                      <strong> Queja:</strong> malestar o descontento respecto a la atencion recibida.
                    </span>
                  </div>
                </div>

                <div className="lr-campo">
                  <label>Tipo de bien <span className="lr-req">*</span></label>
                  <div className="lr-radio-group">
                    {[{val:'producto',label:'Producto (material descargable, kit, juego)'},{val:'servicio',label:'Servicio (curso, formacion, aula virtual)'}].map(function(op) {
                      return (
                        <label key={op.val} className={'lr-radio ' + (form.tipo_bien === op.val ? 'lr-radio--active' : '')}>
                          <input type="radio" name="tipo_bien" value={op.val} checked={form.tipo_bien === op.val} onChange={function(e) { set('tipo_bien', e.target.value); }}/>
                          {op.label}
                        </label>
                      );
                    })}
                  </div>
                </div>

                <div className="lr-campo">
                  <label>Descripcion del bien o servicio <span className="lr-req">*</span></label>
                  <input type="text" placeholder="Ej: Curso de intervencion en lenguaje expresivo" value={form.descripcion_bien} onChange={function(e) { set('descripcion_bien', e.target.value); }} className={errores.descripcion_bien ? 'lr-input--error' : ''}/>
                  {errores.descripcion_bien && <span className="lr-error">{errores.descripcion_bien}</span>}
                </div>

                <div className="lr-grid-2">
                  <div className="lr-campo">
                    <label>Monto reclamado (S/.)</label>
                    <input type="number" placeholder="0.00" min="0" step="0.01" value={form.monto} onChange={function(e) { set('monto', e.target.value); }}/>
                  </div>
                  <div className="lr-campo">
                    <label>Codigo de pedido (si tienes)</label>
                    <input type="text" placeholder="Ej: C00123456" value={form.pedido_codigo} onChange={function(e) { set('pedido_codigo', e.target.value); }}/>
                  </div>
                </div>

                <div className="lr-form-actions">
                  <button type="button" className="lr-btn lr-btn--ghost" onClick={function() { setPaso(1); }}>
                    Atras
                  </button>
                  <button type="button" className="lr-btn lr-btn--primary" onClick={siguientePaso}>
                    Continuar <IconArrow/>
                  </button>
                </div>
              </div>
            )}

            {/* ── PASO 3: Detalle del reclamo ── */}
            {paso === 3 && (
              <form className="lr-form-section" onSubmit={handleEnviar}>
                <div className="lr-form-section__head">
                  <IconBook/>
                  <div>
                    <h2>Detalle del {form.tipo_reclamo}</h2>
                    <p>Describe con claridad lo ocurrido y lo que solicitas como solucion.</p>
                  </div>
                </div>

                <div className="lr-campo">
                  <label>Descripcion del {form.tipo_reclamo} <span className="lr-req">*</span></label>
                  <textarea
                    rows={5}
                    placeholder={'Describe detalladamente lo ocurrido, fecha aproximada y cualquier informacion relevante...'}
                    value={form.detalle}
                    onChange={function(e) { set('detalle', e.target.value); }}
                    className={errores.detalle ? 'lr-input--error' : ''}
                  />
                  <span className="lr-contador">{form.detalle.length} caracteres (minimo 20)</span>
                  {errores.detalle && <span className="lr-error">{errores.detalle}</span>}
                </div>

                <div className="lr-campo">
                  <label>Pedido del consumidor <span className="lr-req">*</span></label>
                  <textarea
                    rows={3}
                    placeholder="Indica que solucion o accion esperas por parte de Centro Comunicar..."
                    value={form.pedido_consumidor}
                    onChange={function(e) { set('pedido_consumidor', e.target.value); }}
                    className={errores.pedido_consumidor ? 'lr-input--error' : ''}
                  />
                  {errores.pedido_consumidor && <span className="lr-error">{errores.pedido_consumidor}</span>}
                </div>

                <div className="lr-resumen-box">
                  <h4>Resumen de tu {form.tipo_reclamo}</h4>
                  <div className="lr-resumen-grid">
                    <div><span>Consumidor</span><strong>{form.nombres} {form.apellidos}</strong></div>
                    <div><span>Documento</span><strong>{form.tipo_doc}: {form.num_doc}</strong></div>
                    <div><span>Email</span><strong>{form.email}</strong></div>
                    <div><span>Tipo</span><strong style={{textTransform:'capitalize'}}>{form.tipo_reclamo}</strong></div>
                    <div><span>Bien/Servicio</span><strong>{form.descripcion_bien}</strong></div>
                    {form.monto && <div><span>Monto</span><strong>S/. {parseFloat(form.monto).toFixed(2)}</strong></div>}
                  </div>
                </div>

                <div className="lr-campo">
                  <label className="lr-checkbox lr-checkbox--terminos">
                    <input type="checkbox" checked={form.acepta_terminos} onChange={function(e) { set('acepta_terminos', e.target.checked); }}/>
                    <span>
                      Declaro que la informacion proporcionada es veridica y autorizo el tratamiento de mis datos
                      personales para la atencion del presente {form.tipo_reclamo}, conforme a la
                      Ley N 29733 - Ley de Proteccion de Datos Personales.
                    </span>
                  </label>
                  {errores.acepta_terminos && <span className="lr-error">{errores.acepta_terminos}</span>}
                </div>

                {errores.submit && (
                  <div className="lr-error-box">
                    <IconAlert/> {errores.submit}
                  </div>
                )}

                <div className="lr-form-actions">
                  <button type="button" className="lr-btn lr-btn--ghost" onClick={function() { setPaso(2); }}>
                    Atras
                  </button>
                  <button type="submit" className="lr-btn lr-btn--primary" disabled={enviando}>
                    {enviando
                      ? <span><IconSpinner/> Enviando...</span>
                      : <span><IconBook/> Enviar {form.tipo_reclamo}</span>
                    }
                  </button>
                </div>
              </form>
            )}

          </div>
        )}

        {/* ════════ TAB CONSULTAR ════════ */}
        {tab === 'consultar' && (
          <div className="lr-consulta-wrap">
            <div className="lr-consulta-head">
              <IconSearch/>
              <div>
                <h2>Consultar estado de reclamo</h2>
                <p>Ingresa el codigo recibido en tu correo y tu email para ver el estado de tu caso.</p>
              </div>
            </div>
            <form className="lr-consulta-form" onSubmit={handleConsultar}>
              <div className="lr-campo">
                <label>Codigo de reclamo</label>
                <input type="text" placeholder="Ej: REC-2025-00001" value={codConsulta} onChange={function(e) { setCodConsulta(e.target.value.toUpperCase()); }}/>
              </div>
              <div className="lr-campo">
                <label>Correo electronico</label>
                <input type="email" placeholder="El email con que registraste el reclamo" value={emailConsulta} onChange={function(e) { setEmailConsulta(e.target.value); }}/>
              </div>
              {errorConsulta && (
                <div className="lr-error-box"><IconAlert/> {errorConsulta}</div>
              )}
              <button type="submit" className="lr-btn lr-btn--primary" disabled={consultando}>
                {consultando ? <span><IconSpinner/> Consultando...</span> : <span><IconSearch/> Consultar estado</span>}
              </button>
            </form>

            {resultConsulta && (
              <div className="lr-consulta-resultado">
                <div className="lr-consulta-resultado__head">
                  <div>
                    <span className="lr-consulta-codigo">{resultConsulta.codigo}</span>
                    <p style={{fontSize:'.8rem',color:'#5a6a63',marginTop:'.2rem'}}>
                      Registrado el {new Date(resultConsulta.fecha_registro).toLocaleDateString('es-PE')}
                    </p>
                  </div>
                  <span
                    className="lr-estado-badge"
                    style={{
                      background: (ESTADO_LABELS[resultConsulta.estado] || {}).bg || '#f3f4f6',
                      color: (ESTADO_LABELS[resultConsulta.estado] || {}).color || '#6b7280',
                    }}
                  >
                    {(ESTADO_LABELS[resultConsulta.estado] || {}).label || resultConsulta.estado}
                  </span>
                </div>
                <div className="lr-consulta-detalle">
                  <div><span>Tipo</span><strong style={{textTransform:'capitalize'}}>{resultConsulta.tipo_reclamo}</strong></div>
                  <div><span>Bien/Servicio</span><strong>{resultConsulta.descripcion_bien}</strong></div>
                  <div className="lr-consulta-detalle__full"><span>Detalle</span><p>{resultConsulta.detalle}</p></div>
                  <div className="lr-consulta-detalle__full"><span>Lo que solicita</span><p>{resultConsulta.pedido_consumidor}</p></div>
                  {resultConsulta.respuesta_admin && (
                    <div className="lr-consulta-detalle__full lr-consulta-detalle__resp">
                      <span>Respuesta del proveedor</span>
                      <p>{resultConsulta.respuesta_admin}</p>
                      {resultConsulta.fecha_respuesta && (
                        <em>Respondido el {new Date(resultConsulta.fecha_respuesta).toLocaleDateString('es-PE')}</em>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

      </div>

      {/* FOOTER LEGAL */}
      <div className="lr-footer-legal">
        <div className="lr-footer-legal__inner">
          <div className="lr-footer-legal__empresa">
            <LogoComunicar height={32}/>
            <div>
              <strong>COMUNICAR DESARROLLO Y LENGUAJE EIRL</strong>
              <span>RUC: 20615646939 | centrocomunicar.com</span>
            </div>
          </div>
          <p>
            Segun el Art. 150 del Codigo de Proteccion y Defensa del Consumidor (Ley N 29571),
            todo establecimiento comercial debe contar con un Libro de Reclamaciones. El proveedor
            debera dar respuesta al reclamo en un plazo no mayor a 30 dias habiles.
          </p>
          <Link to="/" className="lr-footer-legal__volver">← Volver al inicio</Link>
        </div>
      </div>

    </div>
  );
}